import QtyCounter from 'components/QtyCounter';
import { useState } from 'react';
import { Button, Modal } from 'reactstrap';

const minQty = 41;
const ModalProPlus = ({ isShow, onClose, onSubmit, isLoadingSubmit }) => {
  const [step, setStep] = useState(1);
  const [qty, setQty] = useState(minQty);
  const [isNotInterested, setIsNotInterested] = useState(false);

  const onLocalClose = () => {
    setStep(1);
    setIsNotInterested(false);
    setQty(minQty);
    onClose();
  };

  return (
    <Modal
      className="modal-dialog-centered modal-danger"
      contentClassName="bg-gradient-danger"
      isOpen={isShow}
      backdrop="static"
      keyboard={false}>
      <div className="modal-header justify-content-center">
        <h6 className="modal-title">Subscribe to Pro+</h6>
      </div>
      <div className="modal-body">
        <div className="py-3 text-center">
          {isNotInterested ? (
            <p>
              It seems that the Pro+ plan isn't the best option for you. Please choose a different
              plan or contact us for more information.
            </p>
          ) : (
            <>
              {step === 2 ? (
                <>
                  <p>How many employees do you have?</p>
                  <div className="d-flex justify-content-center">
                    <QtyCounter onChange={setQty} min={minQty} />
                  </div>
                </>
              ) : step === 1 ? (
                <>
                  <p>
                    This plan is designed for companies with more than 40 staff.
                    <br />
                    It will give you full access to the platform.
                  </p>
                  <p>Do you have more than 40 staff?</p>
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </div>
      <div className="modal-footer">
        {isNotInterested ? (
          <div>
            <Button color="link" className="text-white" onClick={onLocalClose}>
              Close
            </Button>
          </div>
        ) : (
          <>
            {step === 2 && (
              <div className="d-flex">
                <Button color="link" className="text-white" onClick={onLocalClose}>
                  Cancel
                </Button>
                <Button
                  className="btn btn-white"
                  onClick={() => onSubmit(qty)}
                  disabled={isLoadingSubmit}>
                  {isLoadingSubmit && <span>Loading...</span>}
                  {!isLoadingSubmit && <span>Subscribe to Pro+</span>}
                </Button>
              </div>
            )}
            {step === 1 && (
              <div className="d-flex">
                <Button
                  color="link"
                  className="text-white"
                  onClick={() => setIsNotInterested(true)}>
                  No
                </Button>

                <Button className="btn btn-white" onClick={() => setStep(2)}>
                  Yes
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export default ModalProPlus;
